export const BASE_URL_SANCTUM = '/sanctum/csrf-cookie';
export const RECAPTCHA_SITE_KEY = process.env.MIX_RECAPTCHA_SITE_KEY;
export const SECONDARY_FORM_TOPICS = ['ČOV', 'SEPTIK', 'VP', 'KP', 'jiné'];
export const TOPICS_TITLES = [
  { id: 'ČOV', title: 'Čistička odpadních vod' },
  { id: 'SEPTIK', title: 'Tříkomorový septik' },
  { id: 'VP', title: 'Vodovodní přípojka' },
  { id: 'KP', title: 'Kanalizační přípojka' },
  { id: 'jiné', title: 'Jiný' },
];
